import { useLocation } from 'react-router-dom';
import { parseQueryParams } from 'src/utils/parse-query-params';

export function useQueryParams() {
  const location = useLocation();

  return parseQueryParams(location.search);
}
